import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarModule, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Alert, AlertType } from '../../models/alert';
import { AlertService } from '../../services/alert.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'tt-alert',
  imports: [
    MatSnackBarModule,
    MatIconModule,
    TranslateModule
  ],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: true
})
export class AlertComponent implements OnInit {

  @ViewChild('snackBarTemplate')
  snackBarTemplate: TemplateRef<any>;

  @Input() id = 'default-alert';
  @Input() fade = true;


  currentAlert: Alert;
  // alerts: Alert[] = [];
  alertSubscription: Subscription;
  routeSubscription: Subscription;

  constructor(
    private router: Router,
    public alertService: AlertService,
    private _snackBar: MatSnackBar) { }

  ngOnInit() {

    // subscribe to new alert notifications
    this.alertSubscription = this.alertService.onAlert(this.id)
      .subscribe(alert => {
        if (alert.message) {
          this.currentAlert = alert;
          this.openSnackBar(alert.message, alert.autoClose, alert.type, alert.verticalPos, alert.horizontalPos);
        } else {
          // clear alerts when an empty alert is received
          this.closeSnackBar();
        }

        // clear alerts when an empty alert is received
        // if (!alert.message) {
        //   // filter out alerts without 'keepAfterRouteChange' flag
        //   this.alerts = this.alerts.filter(x => x.keepAfterRouteChange);

        // remove 'keepAfterRouteChange' flag on the rest
        // this.alerts.forEach(x => delete x.keepAfterRouteChange);
        // return;
        // }

        // add alert to array
        // this.alerts.push(alert);


        // // auto close alert if required
        // if (alert.autoClose) {
        //   setTimeout(() => this.removeAlert(alert), 3000);
        // }
      });

    // clear alerts on location change
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.alertService.clear(this.id);
      }
    });
  }

  openSnackBar(content: string, autoclose?: boolean, type?: AlertType, verticalPos?: MatSnackBarVerticalPosition, horizontalPos?: MatSnackBarHorizontalPosition) {
    let horizontalPosition: MatSnackBarHorizontalPosition = horizontalPos || 'center';
    let verticalPosition: MatSnackBarVerticalPosition = verticalPos || 'top';
    this._snackBar.openFromTemplate(this.snackBarTemplate,
      {
        duration: autoclose ? 1000 * 5 : undefined,
        horizontalPosition: horizontalPosition,
        verticalPosition: verticalPosition,
        data: content
      });

  }

  closeSnackBar() {
    this._snackBar.dismiss();
  }

  ngOnDestroy() {
    // unsubscribe to avoid memory leaks
    this.alertSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  // removeAlert(alert: Alert) {
  //   // check if already removed to prevent error on auto close
  //   if (!this.alerts.includes(alert)) return;

  //   if (this.fade) {
  //     // fade out alert
  //     this.alerts.find(x => x === alert).fade = true;

  //     // remove alert after faded out
  //     setTimeout(() => {
  //       this.alerts = this.alerts.filter(x => x !== alert);
  //     }, 250);
  //   } else {
  //     // remove alert
  //     this.alerts = this.alerts.filter(x => x !== alert);
  //   }
  // }
}

